// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tickets_DeletecategoriaticketResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Tickets_DeletecategoriaticketResponseDados {
deleted: boolean
}

export type Tickets_DeletecategoriaticketResponse = ApiResponse<Tickets_DeletecategoriaticketResponseDados>;

registerResponseContract('Tickets_DeletecategoriaticketResponse', {
  deleted: { type: 'boolean', required: true },
})
